import React, { useState, useEffect } from 'react';
import './AnalyzeRequest.scss'; // Подключаем стили
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { miniApp } from '@telegram-apps/sdk-react';
import { useNavigate } from "react-router-dom";
import { useMainButton } from '../../hooks/useMainButton';
import { FreeMode } from 'swiper/modules';
import { useBackButtonManager } from '../../contexts/BackButtonContext';
import { useCart } from '../../contexts/CartContext';
import api from "../../api";
import { useToast } from "../../contexts/ToastContext";
import Button from '../../components/ui/Button';

const AnalyzeRequest = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { action, clear } = useBackButtonManager();
  const {
          setIsCartOpen,
          setIsEnable,
          cartItems
        } = useCart();
  useEffect(() => {
    window.scrollTo(0, 0);
    miniApp.setBackgroundColor('#1D1D20');
    miniApp.setHeaderColor('#1D1D20');
    action(() => navigate("/"));
    setIsEnable(false);
    return () => {
      setIsEnable(true);
      clear();
    };
  }, []);
  useMainButton();

  const [load, setLoad] = useState(false);

  const [images, setImages] = useState([]);
  const [urlname, setUrlname] = useState("");
  const [comment, setComment] = useState("");

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = [];

    const MAX_IMAGES = 10;

    setImages((prevImages) => {
      const remainingSlots = MAX_IMAGES - prevImages.length;

      if (remainingSlots <= 0) {
        showToast(`Максимум ${MAX_IMAGES} изображений уже загружено`);
        return prevImages;
      }

      for (const file of files) {
        if (validFiles.length >= remainingSlots) {
          showToast(`Можно загрузить только ${MAX_IMAGES} изображений`);
          break;
        }

        const isImage = file.type === "image/jpeg" || file.type === "image/png";
        const isSizeOk = file.size <= 10 * 1024 * 1024;

        if (!isImage) {
          showToast(`Файл ${file.name} не является JPG/PNG`);
          continue;
        }

        if (!isSizeOk) {
          showToast(`Файл ${file.name} превышает 10MB`);
          continue;
        }

        validFiles.push({
          file,
          preview: URL.createObjectURL(file),
        });
      }

      return [...prevImages, ...validFiles];
    });
  };



  const handleRemove = (index) => {
    setImages((prev) => {
      URL.revokeObjectURL(prev[index].preview);
      return prev.filter((_, i) => i !== index);
    });
  };
  
  useEffect(() => {
    window.scrollTo(0, 0);
      miniApp.setBackgroundColor('#161618');
      miniApp.setHeaderColor('#161618');
    return () => {
      miniApp.setBackgroundColor('#1D1D20');
      miniApp.setHeaderColor('#1D1D20');
    };
  }, []);

  const sendRequest = async () => {
    setLoad(true);
    if (!urlname.trim()) {
      showToast("Укажите ссылку на товар");
      return setLoad(false);
    }

    if (images.length === 0) {
      showToast("Пожалуйста, загрузите хотя бы одно изображение.");
      return setLoad(false);
    }

    const formData = new FormData();
    formData.append('url', urlname);
    formData.append('comment', comment);
    images.forEach((image) => {
      formData.append('files', image.file);
    });

    try {
      const response = await api.post("/api/AnalyzeRequest/SendAnalyze", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('Успешно отправлено:', response.data);
      setLoad(false)
      navigate('/success');
    } catch (error) {
      console.error('Ошибка при отправке:', error);
      setLoad(false)
      showToast('Произошла ошибка при отправке заявки.');
    }
  };

  return (
    <div className="analyze-page page-classes">
      <h2 className="title">Заявка на просчет</h2>
      <div className='form-page'>
        <div className="input-group">
          <input disabled={load} type="text" onChange={(e) => setUrlname(e.target.value)} className="form-control" placeholder="Ссылка на товар" />
        </div>
        <div className="input-group">
          <textarea disabled={load} type="text" onChange={(e) => setComment(e.target.value)} className="form-control" cols={4} placeholder="Модель, вариация товара или характеристика "></textarea>
        </div>
        <div className={`upload-container ${images.length > 0 ? 'is-images mt-3' : ''}`}>
          <Swiper
            modules={[FreeMode]}
            spaceBetween={16}
            slidesPerView="auto"
            freeMode={true}
          >
            {images.map((image, index) => (
              <SwiperSlide key={index} style={{ width: 'auto' }}>
                <div className="visibleContainer">
                  <div
                    className="delete-image"
                    style={{ cursor: 'pointer', zIndex: 1 }}
                    onClick={() => handleRemove(index)}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22ZM9.56564 8.43427C9.25322 8.12185 8.74669 8.12185 8.43427 8.43427C8.12185 8.74669 8.12185 9.25322 8.43427 9.56564L10.8686 12L8.43427 14.4343C8.12185 14.7467 8.12185 15.2532 8.43427 15.5656C8.74669 15.8781 9.25322 15.8781 9.56564 15.5656L12 13.1313L14.4343 15.5656C14.7467 15.8781 15.2532 15.8781 15.5656 15.5656C15.8781 15.2532 15.8781 14.7467 15.5656 14.4343L13.1313 12L15.5656 9.56564C15.8781 9.25322 15.8781 8.74669 15.5656 8.43427C15.2532 8.12185 14.7467 8.12185 14.4343 8.43427L12 10.8686L9.56564 8.43427Z" fill="#1D1D20"/>
<path d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C6.27096e-07 5.37258 5.37258 6.27077e-07 12 0ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM14.4346 8.43457C14.747 8.12215 15.253 8.12215 15.5654 8.43457C15.8778 8.74699 15.8778 9.25303 15.5654 9.56543L13.1309 12L15.5654 14.4346C15.8778 14.747 15.8778 15.253 15.5654 15.5654C15.253 15.8778 14.747 15.8778 14.4346 15.5654L12 13.1309L9.56543 15.5654C9.25303 15.8778 8.74699 15.8778 8.43457 15.5654C8.12215 15.253 8.12215 14.747 8.43457 14.4346L10.8682 12L8.43457 9.56543C8.12215 9.25301 8.12215 8.74699 8.43457 8.43457C8.74699 8.12215 9.25301 8.12215 9.56543 8.43457L12 10.8682L14.4346 8.43457Z" fill="white"/>
</svg>


                  </div>
                  <img className="visibleImage" src={image.preview} alt={`img-${index}`} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="upload-photo">
            <label className='upload-label btn btn-secondary'>
              Загрузите фото или скрин <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C12.5523 3 13 3.44772 13 4V13.5858L15.2929 11.2929C15.6834 10.9024 16.3166 10.9024 16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L11 13.5858V4C11 3.44772 11.4477 3 12 3ZM3 20C3 19.4477 3.44772 19 4 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20Z" fill="white"/>
                </svg>
              <input
                type="file"
                accept="image/*"
                multiple
                className="d-none"
                onChange={handleFileChange}
                disabled={load}
              />
            </label>
          </div>
        </div>
      </div>
      <div className='btn-container-fixed'>
        <Button onClick={sendRequest} load={load} className='btn-primary large'>
            Отправить
        </Button>
      </div>
    </div>
  );
};

export default AnalyzeRequest;
